import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useApi, useAuth } from 'hooks';

type Payload = {
  userId: string;
  name: string;
  dosage?: string;
  directions?: string;
  comment?: string;
};

const useCreateUserMedication = () => {
  const queryClient = useQueryClient();
  const { api } = useApi({ throwIfError: true });
  const { userToken } = useAuth();

  const mutation = useMutation({
    mutationFn: async ({
      userId,
      name,
      dosage,
      directions,
      comment,
    }: Payload) => {
      return await api({
        route: `/private/dashboard/user/${userId}/medications/`,
        method: 'POST',
        token: userToken,
        payload: {
          name,
          dosage,
          directions,
          comment,
        },
      });
    },
    onSuccess: (_, { userId }) => {
      queryClient.invalidateQueries({
        queryKey: ['user-medications', userToken, userId],
      });
      queryClient.invalidateQueries({
        queryKey: ['user-medications-prescriptions', userToken, userId],
      });
    },
  });

  return {
    mutation,
  };
};

export default useCreateUserMedication;
